<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Anexos" :content="meta.total" :icon="['far','file']" />
      <sys-widget title="Monto estimado" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import attachmentService from '@/services/attachments'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'Attachments',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Anexos',
      headers: [
        { text: 'Id', value: 'attachment_id' },
        { text: 'Folio Contrato', value: 'contract_folio' },
        { text: 'Folio Pagare', value: 'promissory_folio' },
        { text: 'Acreedor', value: 'investor_name' },
        { text: 'Monto de inversión', value: 'amount', filter: formatCurrency },
        { text: 'Corte (Día)', value: 'cut_day' },
        { text: 'Tasa (%)', value: 'interest_rate' },
        { text: 'Tipo de Tasa', value: 'rate_type' },
        { text: 'Frecuencia', value: 'frequency' },
        { text: 'Fecha Desde', value: 'date_init' },
        { text: 'Fecha Hasta', value: 'date_expire' },
        { text: 'Estatus', value: 'state' }
      ],
      items: [],
      filtered_items: [],
      error_message: 'Cargando Anexos',
      detail_route: 'attachment',
      create_route: 'attachment_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'name',
          name: 'Acreedor',
          hint: 'Acreedor',
          icon: 'user',
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.investor_name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'contract_folio',
          name: 'Contrato',
          hint: '',
          icon: null,
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.contract_folio.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'state',
          name: 'Estatus',
          hint: 'Todos',
          icon: null,
          type: 'select',
          value: '',
          options: [{ value: 'Registrado', text: 'Registrado', selected: true }, { value: 'En firma', text: 'En firma' }, { value: 'En archivo', text: 'En archivo' }, { value: 'Pagaré Cancelado', text: 'Pagaré Cancelado' }],
          size: 4,
          validator: (item, value) => item.state === value
        },
        {
          id: 'investment_from',
          name: 'Inversión Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 2,
          value: '',
          validator: (item, value) => item.amount >= value
        },
        {
          id: 'investment_to',
          name: 'Inversión Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 2,
          value: '',
          validator: (item, value) => item.amount <= value
        },
        {
          id: 'date_from',
          name: 'Expira desde',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 2,
          value: '',
          validator: (item, value) => new Date(item.date_expire) >= new Date(reverseDate(value))
        },
        {
          id: 'date_to',
          name: 'Expira Hasta',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 2,
          value: '',
          validator: (item, value) => new Date(item.date_expire) <= new Date(reverseDate(value))
        },
        {
          id: 'cut_day',
          name: 'Fecha de corte',
          hint: 'Todos',
          icon: 'calendar-alt',
          type: 'select',
          value: '',
          options: [
            {value: '7', text: 'Día 7'},
            {value: '15', text: 'Día 15'},
            {value: '21', text: 'Día 21'},
            {value: 'Ultimo del mes', text: 'Ultimo del mes'}
          ],
          size: 4,
          validator: (item, value) => item.cut_day === value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      attachmentService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/attachments/Attachments.vue